import {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutUs = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, offset: 250 });
    });
    return (
            <div className="container">
                <div id="whoweare" className="row mt-5">
                    <div className="col-12 text-center text-white">
                        <h1 className="fs-2 gradient-text fw-bolder" data-aos="zoom-in">ABOUT US</h1>
                    </div>
                </div>
                <div className="row my-5">
                    <div className="bg-transparent text-white col-12 border rounded-5 shadow p-5 fs-2" data-aos="zoom-in">
                        
                        <p>
                            At Shri Hans Frolic Energy & Tech LLP, we harmonize spirituality and
                            innovation to deliver transformative solutions in energy, technology,
                            sports infrastructure, and civil construction. Rooted in the spiritual
                            essence symbolized by the name "Hans" we integrate traditional values
                            with modern advancements to create impactful and sustainable projects.
                        </p>

                        <p>
                            Our expertise spans developing cutting-edge technology solutions,
                            promoting emerging sports like Pickleball, and executing large-scale civil
                            construction projects. With a global perspective, strong industry
                            connections, and a commitment to excellence, we aim to shape a future
                            where spiritual energy fuels sustainable development and innovation.
                        </p>

                        <p>
                            To fuse spiritual principles with modern innovation, delivering
                            transformative solutions in energy, technology, and infrastructure that drive
                            holistic progress and inspire positive change in communities globally.
                            To become a global leader in energy and infrastructure development by
                            harnessing spirituality and innovation, creating sustainable, impactful
                            projects that enhance well-being and align with evolving global needs.
                        </p>
                        
                    </div>
                </div>
            </div>
    )
}

export default AboutUs;